import React, { useEffect, useState } from 'react';
import {
  Form,
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { toast } from 'react-toastify';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, Controller } from 'react-hook-form';
import './SaveProcessClaimModal.scss';
import { initialValues, validationSchema } from './constants';

const SAVE_NO_CHANGE_TOAST_ID = 'SaveNoChangeToastError';

function SaveProcessClaimModal({
  isOpen,
  toggle,
  handleOnSubmit,
  isLoading,
  getChangeLog,
  type = 'save',
}) {
  const [isChanged, setIsChanged] = useState(false);
  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    reset,
  } = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
    mode: 'onChange',
  });

  const onSubmit = async values => {
    if (!isChanged) {
      if (!toast.isActive(SAVE_NO_CHANGE_TOAST_ID)) {
        toast.error('No changes made to save.', {
          className: 'toast-error',
          toastId: SAVE_NO_CHANGE_TOAST_ID,
        });
        toggle();
        return;
      }
    }
    const payload = {
      ...values,
    };
    await handleOnSubmit(payload, type);
  };

  // always reset when modal opens
  useEffect(() => {
    if (isOpen) {
      reset(initialValues);
    }
  }, [isOpen, reset]);

  useEffect(() => {
    async function getChangeLogString() {
      return getChangeLog ? getChangeLog() : '';
    }
    async function fetchChangeLog() {
      if (isOpen) {
        setIsChanged(false);
        const changeLog = await getChangeLogString();
        if (!changeLog) {
          reset({
            changeReason: 'No changes made',
            changeComments: '',
          });
          return;
        }
        reset({
          changeReason: changeLog,
          changeComments: '',
        });
        setIsChanged(true);
      }
    }
    fetchChangeLog();
  }, [isOpen, getChangeLog, reset]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="xs">
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="d-flex flex-column gap-3"
      >
        <ModalBody>
          <div className="mb-3">
            <h5>Following Changes have been performed</h5>
          </div>
          <Controller
            control={control}
            name="changeReason"
            render={({ field }) => (
              <Input
                {...field}
                type="textarea"
                className={`form-control  external-filter-input ${errors.reason ? 'is-invalid' : ''}`}
                placeholder="Enter Reason"
                rows="6"
                disabled
              />
            )}
          />
          {errors.reason && (
            <div className="invalid-feedback">{errors.reason.message}</div>
          )}
          <div className="mt-2">
            <Label>
              Comments<span className="text-danger">*</span>
            </Label>
            <Controller
              control={control}
              name="changeComments"
              render={({ field }) => (
                <Input
                  {...field}
                  type="textarea"
                  className={`form-control  external-filter-input ${errors.reason ? 'is-invalid' : ''}`}
                  placeholder="Enter Reason"
                  rows="3"
                />
              )}
            />
            {errors.reason && (
              <div className="invalid-feedback">{errors.reason.message}</div>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <Col>
            <button
              type="button"
              onClick={toggle}
              className="tr-cancel-btn w-100"
            >
              Cancel
            </button>
          </Col>
          <Col>
            <button
              onClick={handleSubmit(onSubmit)}
              type="button"
              className="tr-confirm-btn w-100"
              disabled={!isValid || isLoading}
            >
              {isLoading ? 'Saving...' : 'Save'}
            </button>
          </Col>
        </ModalFooter>
      </Form>
    </Modal>
  );
}

export default SaveProcessClaimModal;
